import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Input, Button, Hint, ErrorSummary } from 'govuk-react-jsx';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  getLinkedEnterpriseNumber,
  setLinkedEnterpriseNumber,
  setCompanyData,
} from '../../features/registration/registrationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { checkValidLinkedEnterprise } from '../../regex/regex';
import { getCompanyData } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const LinkedEnterpriseNumber = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const linkedEnterpriseNumberRedux = useSelector(getLinkedEnterpriseNumber);
  const [errorMsg, setErrorMsg] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();
  useTitle(
    'landlordReg.LinkedEnterpriseNumber.s12',
    'Enter company registration number - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const handleCompanyRegistration = (event) => {
    dispatch(setLinkedEnterpriseNumber(event.target.value));
  };

  const errorInvalidFormat = copyProvider.getCopy(
    'landlordReg.LinkedEnterpriseNumber.s1',
    'Enter a valid Company Registration number that consists of 8 characters and can contain letters and numbers'
  );

  const errorNotValidAPI = copyProvider.getCopy(
    'landlordReg.LinkedEnterpriseNumber.s2',
    'Entered Company Registration number not recognised'
  );

  const errorAlreadyExistsAPI = copyProvider.getCopy(
    'landlordReg.LinkedEnterpriseNumber.s9',
    'This number is already in use with another account'
  );

  const showErrorInvalidFormat = {
    children: errorInvalidFormat,
  };

  const showErrorNotValidAPI = {
    children: errorNotValidAPI,
  };

  const showErrorAlreadyExistsAPI = {
    children: errorAlreadyExistsAPI,
  };

  const handleBtnClick = () => {
    if (checkValidLinkedEnterprise.test(linkedEnterpriseNumberRedux)) {
      setErrorMsg(null);

      getCompanyData({ companyRegNumber: linkedEnterpriseNumberRedux })
        .then((response) => {
          const { data } = response;
          dispatch(setCompanyData(data));
          if (
            data !== null &&
            data.companyRegNumber === linkedEnterpriseNumberRedux
          ) {
            history.push('/landlordReg/confirm-business-details');
          } else {
            setErrorMsg(showErrorNotValidAPI);
            setErrorList([
              { ...showErrorNotValidAPI, href: '#companyRegistrationNumber' },
            ]);
          }
        })
        .catch((error) => {
          if (error.code === 'functions/already-exists') {
            setErrorMsg(showErrorAlreadyExistsAPI);
            setErrorList([
              {
                ...showErrorAlreadyExistsAPI,
                href: '#companyRegistrationNumber',
              },
            ]);
          } else {
            setErrorMsg(showErrorNotValidAPI);
            setErrorList([
              { ...showErrorNotValidAPI, href: '#companyRegistrationNumber' },
            ]);
          }
        });
    } else if (!checkValidLinkedEnterprise.test(linkedEnterpriseNumberRedux)) {
      setErrorMsg(showErrorInvalidFormat);
      setErrorList([
        { ...showErrorInvalidFormat, href: '#companyRegistrationNumber' },
      ]);
    }
  };
  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <div className="govuk-form-group">
        <h1 className="govuk-heading-xl">
          {copyProvider.getCopy(
            'landlordReg.LinkedEnterpriseNumber.s3',
            'Enter the company registration number of the enterprise that owns or controls your company'
          )}
        </h1>
        <p className="govuk-body">
          {copyProvider.getCopy(
            'landlordReg.LinkedEnterpriseNumber.s4',
            'We will use this to confirm the details of your linked enterprise company'
          )}
        </p>

        <p className="govuk-body">
          {copyProvider.getCopy(
            'landlordReg.LinkedEnterpriseNumber.s10',
            'The company registration number is the best number to use for a fast registration.'
          )}
        </p>

        <div className="govuk-form-group">
          <div className="govuk-body">
            <Input
              errorMessage={errorMsg}
              hint={{
                children: copyProvider.getCopy(
                  'landlordReg.LinkedEnterpriseNumber.s6',
                  'This is the number assigned by Companies House when a company is formed and officially registered.'
                ),
              }}
              label={{
                children: copyProvider.getCopy(
                  'landlordReg.LinkedEnterpriseNumber.s5',
                  'National insurance number'
                ),
              }}
              id="companyRegistrationNumber"
              className="govuk-input govuk-!-width-two-thirds"
              name="companyRegistration"
              type="text"
              value={linkedEnterpriseNumberRedux}
              onChange={(event) => handleCompanyRegistration(event)}
            />
          </div>
        </div>
      </div>
      <div className="govuk-body govuk-!-font-size-19 govuk-!-padding-bottom-6">
        <Link className="govuk-link " to="/landlordReg/company-VAT-number">
          {copyProvider.getCopy(
            'landlordReg.LinkedEnterpriseNumber.s7',
            "I don't have a company registration number"
          )}
        </Link>
        <Hint className="govuk-!-padding-top-4">
          {copyProvider.getCopy(
            'landlordReg.LinkedEnterpriseNumber.s11',
            'You can use the VAT registration number of your controlling enterprise. Ask them for this information.'
          )}
        </Hint>
      </div>

      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy(
          'landlordReg.LinkedEnterpriseNumber.s8',
          'Continue'
        )}
      </Button>
    </>
  );

  return pageModel;
};

export default LinkedEnterpriseNumber;
